(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cn-drawer-region')) {
  customElements.define('cn-drawer-region', class extends HTMLElement {
    connectedCallback() {
      if (this.handleRegion) return;
      this.handleRegion = event => {
        const select = event.target;
        if (!(select instanceof HTMLSelectElement) || !select.form) return;
        select.form.requestSubmit();
      };
      this.addEventListener('change', this.handleRegion);
    }
    disconnectedCallback() {
      this.removeEventListener('change', this.handleRegion);
      this.handleRegion = null;
    }
  });
}

document.addEventListener('toggle', (event) => {
  const details=event.target;
  if(!(details instanceof HTMLDetailsElement)||details.id!=='Details-menu-drawer-container'||!details.open)return;
  const header=document.getElementById('header-component');
  const drawer=details.querySelector('.menu-drawer');
  if(header&&drawer)drawer.style.setProperty('--cn-menu-top',Math.max(0,header.getBoundingClientRect().bottom)+'px');
},true);
  } catch(e) { console.error(e); }
})();

})();
